import { Spin } from "antd"
import { motion } from "motion/react"

import SkeletonBlock from "./SkeletonBlock"

export const PageSpinner = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25, ease: "easeIn" }}
    >
      <span
        style={{
          position: "absolute",
          height: "100vh",
          width: "80vw",
          top: "48%",
          left: "50%",
          transform: "translate(-50%, -25%)",
          opacity: 0.3,
        }}
      >
        <SkeletonBlock count={10} gap={10} />
      </span>
      <span
        style={{
          position: "absolute",
          top: "35%",
          left: "50%",
          transform: "translate(-50%, -25%) scale(3)",
        }}
      >
        <Spin />
      </span>
    </motion.div>
  )
}

export default PageSpinner
